import React, { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ContextGlobal } from "../contexts/ContextGlobal";
import { useMediaPredicate } from "react-media-hook";
import { LoginModal } from "./Modals/LoginModal";
import { SignUpModal } from "./Modals/SignUpModal";
import { Oval, ThreeCircles, ThreeDots } from "react-loader-spinner";

export const NavBar = (props) => {
    const { activePage, session, logout, sessionLoading } = useContext(ContextGlobal);

    const midSizeScreen = useMediaPredicate("(max-width: 1080px)");

    const handleLogout = (e) => {
        e.preventDefault();

        logout();
    };

    const [openMenu, setOpenMenu] = useState(false);

    useEffect(() => {
        if (openMenu) {
            document.body.classList.add("offcanvas-active");
        } else {
            document.body.classList.remove("offcanvas-active");
        }
    }, [setOpenMenu, openMenu]);

    if (activePage.portal) {
        return <></>;
    }

    return (
        <>
            <nav className="navbar navbar-expand-xl navbar-light flex mb-5">
                <div className="container-fluid">
                    <a className="navbar-brand" href="https://www.accumedintel.com/" rel="noopener noreferrer" style={{ marginLeft: midSizeScreen ? "" : "229px", marginTop: midSizeScreen ? "" : "19px" }}>
                        <img src="./img/Logo_Default.png" height={!midSizeScreen ? "57px" : "28vh"} width={!midSizeScreen ? "212px" : ""} alt="Logo" />
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse justify-content-evenly" id="navbarSupportedContent">
                        <ul className="navbar-nav mt-2">
                            <li className="nav-item pb-lg-0 pb-2">
                                <Link className="nav-link nav-link-style" to="/" id="navbarOrder" role="button" reloadDocument>
                                    <span className={"nav-link-span middle " + (activePage.createReport ? "active" : "inactive")} style={{fontSize: "16px"}}>All Products</span>
                                </Link>
                            </li>
                            <li className="nav-item pb-lg-0 pb-2">
                                <Link className="nav-link nav-link-style" to="/my_reports" id="navbarOrder" role="button" reloadDocument>
                                    <span className={"nav-link-span middle " + (activePage.myReports ? "active" : "inactive")} style={{fontSize: "16px"}}>My Reports</span>
                                </Link>
                            </li>
                            {/* <li className="nav-item pb-lg-0 pb-2">
                                <Link className="nav-link nav-link-style" to="/products-and-pricing" id="navbarProducts" role="button" reloadDocument>
                                    <span className={"nav-link-span middle " + (activePage.productsInfo ? "active" : "inactive")} style={{fontSize: "16px"}}>Products & Pricing</span>
                                </Link>
                            </li> */}
                            {/* <li className="nav-item pb-lg-0 pb-2">
                                <Link className="nav-link nav-link-style" to="/faq" id="navbarContact" role="button" reloadDocument>
                                    <span className={"nav-link-span middle " + (activePage.faq ? "active" : "inactive")}>FAQs</span>
                                </Link>
                            </li> */}
                            <li className="nav-item dropdown pb-lg-0 pb-2">
                                <a className="nav-link dropdown-toggle nav-link-style" href="#" id="navbarProducts" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Products
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="navbarProducts">
                                    <li style={{ border: "0px" }} ><a className="dropdown-item" href="https://www.accumedintel.com/medical-cost-projections/" rel="noopener noreferrer" target="_blank">Medical Cost Projection</a></li>
                                    <li style={{ border: "0px" }}><a className="dropdown-item" href="https://www.accumedintel.com/bill-analysis/" rel="noopener noreferrer" target="_blank">Bill Analysis</a></li>
                                    <li style={{ border: "0px" }}><a className="dropdown-item" href="https://www.accumedintel.com/expert-support/" rel="noopener noreferrer" target="_blank">Expert Support</a></li>
                                </ul>
                            </li>
                            {sessionLoading ? (
                                <li style={{ order: midSizeScreen ? "2" : "" }} className={"nav-item pb-lg-0 pb-2" + (session.email ? " d-none" : "")}>
                                    <span className={"nav-link nav-link-style"} style={{ cursor: "pointer" }}>
                                        <span className={"nav-link-span middle " + (activePage.login ? "active" : "inactive")} onClick={(e) => setOpenMenu(false)} data-bs-toggle="modal" data-bs-target="#login">
                                            <ThreeDots color="white" height={20} width={20} />
                                        </span>
                                    </span>
                                </li>
                            ) : (
                                <>
                                    {/* <li
                                    style={{ order: midSizeScreen ? "2" : "" }}
                                    className={"nav-item pb-lg-0 pb-2" + (session.email ? " d-none" : "")}
                                >
                                    <span className={"nav-link nav-link-style"} style={{ cursor: "pointer" }}>
                                        <span
                                            className={
                                                "nav-link-span middle " + (activePage.login ? "active" : "inactive")
                                            }
                                            onClick={(e) => setOpenMenu(false)}
                                            data-bs-toggle="modal"
                                            data-bs-target="#login"
                                        >
                                            Login
                                        </span>
                                    </span>
                                </li> */}
                                    <li
                                        style={{
                                            order: midSizeScreen ? "1" : "",
                                            marginBottom: midSizeScreen ? "10px" : "",
                                            marginTop: midSizeScreen ? "10px" : "",
                                            marginLeft: midSizeScreen ? "0px" : "50px",
                                        }}
                                        className={"nav-item pb-lg-0 pb-2 d-flex" + (session.email ? " d-none" : "")}
                                    >
                                        <button type="button" className="btn btn-primary btn-signup" data-bs-toggle="modal" data-bs-target="#login" onClick={(e) => setOpenMenu(false)} style={{ fontSize: "14pt" }}>
                                            Login / Sign Up
                                        </button>
                                    </li>
                                    <li style={{ order: midSizeScreen ? "3" : "" }} className={"nav-item dropdown pb-lg-0 pb-2" + (!session.email ? " d-none" : "")}>
                                        <span className={"nav-link nav-link-style dropdown-toggle"} style={{ cursor: "pointer" }} id="navbarDarkDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span className={"nav-link-span " + (activePage.login ? "active" : "inactive")}>{session.firstName + " " + session.lastName}</span>
                                        </span>
                                        <ul className="dropdown-menu" aria-labelledby="navbarDarkDropdownMenuLink">
                                            {/* <li><a className="dropdown-item" href="/my_reports">My Reports</a></li> */}
                                            <li style={{ border: "0px" }}>
                                                <Link className={"dropdown-item"} to="/settings" reloadDocument>
                                                    <span onClick={(e) => setOpenMenu(false)}>Settings</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <span className={"dropdown-item"} style={{ cursor: "pointer" }} onClick={handleLogout}>
                                                    <span onClick={(e) => setOpenMenu(false)}>Logout</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>
                </div>
            </nav>
            <LoginModal />
            <SignUpModal />
        </>
    );
};
